import BaseEntity from "@Shared/Entities/AbstractEntities/BaseEntity";
import { countryGroupConstraints } from "./constraints";
import { migrate } from "./migrate";
export default class CountryGroup extends BaseEntity {
    constructor(data = {}) {
        super(migrate(data), countryGroupConstraints);
    }
    get baseUrl() {
        return `${super.baseUrl}/country-groups/${this.id}`;
    }
    get data() {
        const parent = super.data;
        const { version } = this._data;
        const { networkId, name, selectedCountries, type } = this;
        return {
            ...parent,
            version,
            networkId,
            name,
            selectedCountries,
            type,
        };
    }
    get links() {
        return {
            self: `${this.baseUrl}`,
        };
    }
    get networkId() {
        return this._data.networkId;
    }
    get name() {
        return this._data.name;
    }
    get selectedCountries() {
        return this._data.selectedCountries;
    }
    get type() {
        return this._data.type;
    }
}
